import { Injectable } from '@angular/core';

import { MessagingUserSettingOutput } from 'infrastructure/graphql/messaging/user/model/messaging-user-setting.output';
import { UserSettingProperty } from 'user/model/user-setting-property';
import { IUserSettings } from 'user/user-settings';

@Injectable({ providedIn: 'root' })
export class UserSettingsConverterService {
	public userSettingsAsEntity(
		outputs: MessagingUserSettingOutput[]
	): IUserSettings {
		const inactivity = outputs.find(
			(setting) =>
				setting.property ===
				UserSettingProperty.USER_CONNECTION_REMINDER_EMAIL_SEND_ENABLED
		);

		const unfinished = outputs.find(
			(setting) =>
				setting.property ===
				UserSettingProperty.USER_MODULE_UNFINISHED_EMAIL_SEND_ENABLED
		);

		const weeklyReport = outputs.find(
			(setting) =>
				setting.property ===
				UserSettingProperty.USER_WEEKLY_SUMMARY_EMAIL_SEND_ENABLED
		);

		return {
			notifyModuleUnfinished: !unfinished || unfinished.value === 'true',
			notifyWeeklyReport: !weeklyReport || weeklyReport.value === 'true',
			notifyInactivity: !inactivity || inactivity.value === 'true',
		} as IUserSettings;
	}
}
